import { create } from "zustand"
import { getKpiMetricAPI } from "@/apis/apt-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { RESOURCE_KPI_METRICS } from "@/constants/resource-const"

export const kpiMetricStore = create((set) => ({
  kpiMap: { today: RESOURCE_KPI_METRICS },
  carbonMap: { today: {} },
  apiGetKpiMetric: async () => {
    const { sido, kapt_code, ended_at } = aptSearchStore.getState().pickApt

    const result = await getKpiMetricAPI({
      sido,
      kapt_code,
      ended_at
    })

    const kpiMap = {}
    const carbonMap = {}
    for (const period in result) {
      kpiMap[period] = RESOURCE_KPI_METRICS.map((m) => ({
        ...m,
        value: result[period].data[m.key].value,
        unit: result[period].data[m.key].unit,
        diff: result[period].data[m.key].diff,
        isUp: result[period].data[m.key].isUp
      }))

      carbonMap[period] = result[period].carbon
    }

    set({ kpiMap, carbonMap })
  }
}))
